import { tagsById as exif } from "./tags/exif.js";
import { tagsById as gps } from "./tags/gps.js";
import { tagsById as standard } from "./tags/standard.js";
import TIFFDecoder from "./tiff_decoder.js";
function decodeTIFF(data, options) {
    const decoder = new TIFFDecoder(data);
    return decoder.decode(options);
}
function isMultiPage(data) {
    const decoder = new TIFFDecoder(data);
    return decoder.isMultiPage;
}
function pageCount(data) {
    const decoder = new TIFFDecoder(data);
    return decoder.pageCount;
}
const tagNames = {
    exif,
    gps,
    standard,
};
export { decodeTIFF as decode, isMultiPage, pageCount, tagNames };
export {} from "./types.js";
export { default as TiffIfd } from "./tiff_ifd.js";
//# sourceMappingURL=index.js.map